import * as React from 'react';
import { Image } from '@cian/ui-kit/image';
import { IStandardImage } from '../../../../settings';
import * as styles from './Slide.css';

interface ICarouselBannerProps {
  image: IStandardImage;
}

export function Slide(props: ICarouselBannerProps) {
  const { image } = props;

  if (!image.fullUrl) {
    return null;
  }

  return (
    <div className={styles['slide']}>
      <div className={styles['slide__image-wrapper']}>
        <Image src={image.fullUrl} alt="" width="100%" height="100%" objectFit="cover" />
      </div>
    </div>
  );
}
